// extracted by mini-css-extract-plugin
module.exports = {"Testimonials":"Testimonials_Testimonials__251Vf","TestimonialBox":"Testimonials_TestimonialBox__1cCPp","info":"Testimonials_info__1ub7C"};